<template>
    <v-container class="busy-hour">
        <v-row :style="{marginLeft: '0px'}">
            <v-col>
                <v-select class="select" v-model="selectedType" color="#c42111" :items="types" @change="onChange" />
                <span class="text">Top 1</span>
                <v-select class="select" v-model="selectedDevice" color="#c42111" :items="devices" @change="onChange" :disabled="disableControls" />
                <span class="text">busy hour using</span>
                <v-select class="select" v-model="selectedMethod" color="#c42111" :items="methods" @change="onChange" :disabled="disableControls" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'BusyHourDaily',
  props: ['param'],
  data: () => ({
      types: [],
      devices: [],
      methods: [],
      selectedType: "",
      selectedDevice: null,
      selectedMethod: null,
  }),

  computed: {
    disableControls: function() {
        return !(this.selectedType.toLowerCase().includes('busy hour'));
    }
  },

  methods: {
      onChange: function(val) {
            let selectedValue = '';
            selectedValue += `${this.types.indexOf(this.selectedType)} `;
            selectedValue += `${this.devices.indexOf(this.selectedDevice)} `;
            selectedValue += `${this.methods.indexOf(this.selectedMethod)}`;
            this.param.selectedValue = selectedValue;
            if(this.selectedType == "Busy Hour") {
                this.param.humanText = `Top 1 ${this.selectedDevice} busy hour using ${this.selectedMethod}`;
            }
            else {
                this.param.humanText = this.selectedType;
            }

            this.$emit('edit');
      },

      buildList: function() {
            let paramValues = this.param.rpt_param_values.slice(0);
            let paramValuesArray = [[],[],[]];
            let inner = 0;
            for(let i = 0; i < paramValues.length; i++) {
                let paramValue = paramValues[i];
                if(paramValue !== "") {
                    paramValuesArray[inner].push(paramValue);
                }
                else {
                    inner += 1;
                }
            }
            this.types = paramValuesArray[0];
            this.devices = paramValuesArray[1];
            this.methods = paramValuesArray[2];
            this.selectedType = this.types[0];
            this.selectedDevice = this.devices[0];
            this.selectedMethod = this.methods[0];
      },

      setInputsInitialValue: function() {
          if(this.$props.param.encodedValue == undefined) {
              return;
          }
          const value = this.$props.param.encodedValue.split(' ');
          this.selectedType = this.types[parseInt(value[0])];
          this.selectedDevice = this.devices[parseInt(value[1])];
          this.selectedMethod = this.methods[parseInt(value[2])];
      }
  },

  mounted() {
    this.buildList();
    this.setInputsInitialValue();
    this.onChange();
  }

  
};
</script>

<style scoped>

.busy-hour .select {
    display: inline-block;
    margin-right: 1em;
}

.busy-hour .text {
    margin-left: 1em;
    margin-right: 1em;
    margin-top: 1em;
    font-style: italic;
}

.busy-hour .input {
    max-width: 50px;
}

</style>

